import { gql } from 'apollo-boost';

export const setAutoOverdraftLimit = gql`
    mutation SetAutoOverdraftLimit($input: GdSetAutoOverdraftParamsInput!) {
        setAutoOverdraftLimit(input: $input) {
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
    }
`;

export const resetAutoOverdraftLimit = gql`
    mutation ResetAutoOverdraftLimit {
        resetAutoOverdraftLimit {
            autoOverdraftLimit
            validationResult {
                errors {
                    path
                    code
                    params
                }
            }
        }
    }
`;
